import { translate } from "@cdv/jazz-i18n";
import { ColorSchemeContext, useMatchParams } from "@cdv/jazz-ui";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import { SvgIconProps, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { createElement, ReactElement, useContext, useEffect, useState } from "react";
import { Resource as ApiResource } from "../../api";

export enum MatchType {
  Headline = "headline",
  AppBarAction = "appBarAction",
  View = "view",
}

export enum AppResource {
  Homepage = "Homepage",
  Game = "Game",
  GameAnt = "GameAnt",
  Login = "Login",
  Register = "Register",
  HomepageAuth = "HomepageAuth",
  Score = "Score",
  Audio = "Audio",
  Info = "Info",
}

export const Resource = { ...ApiResource, ...AppResource };

export const ResourceIcons: {
  [key in ApiResource]?: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
} = {
  User: PersonIcon,
  Company: BusinessIcon,
};

export enum AppMatchType {
  Breadcrumbs = "AppBreadcrumbs",
  Tabs = "AppTabs",
}

export const getResourceIcon = (resource: ApiResource, props?: SvgIconProps): ReactElement =>
  createElement(ResourceIcons[resource] || "span", props);

export const useOutletBackgroundColor = () => {
  const { isDark } = useContext(ColorSchemeContext);
  return isDark ? "rgb(26, 34, 63)" : "rgb(238, 242, 246)";
};

export const translateDataTitle = () => {
  const { parent } = useMatchParams();
  if (parent === ApiResource.CurrentUser) {
    return translate("Data");
  }
};

export const useOffline = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);
  return isOffline;
};
